import React from 'react';
import Img from 'gatsby-image';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import AltTitle from '../../alt-title';
import TallSquares from '../../../images/svg/squareDotsTall.svg';
import { FaRegThumbsUp, FaPiggyBank, FaBullhorn } from 'react-icons/fa';

const WhyInfluencers = ({ className }) => {
  const data = useStaticQuery(graphql`
    {
      file: contentfulWhyInfluencers {
        tagline
        title
        image {
          fluid(maxWidth: 700) {
            ...GatsbyContentfulFluid_tracedSVG
          }
        }
        bullet1Title
        bullet1Paragraph
        bullet2Title
        bullet2Paragraph
        bullet3Title
        bullet3Paragraph
      }
    }
  `);

  // const data = useStaticQuery(graphql`
  //   {
  //     file: file(relativePath: { eq: "whyMicro.png" }) {
  //       childImageSharp {
  //         fluid(maxWidth: 700) {
  //           ...GatsbyImageSharpFluid_tracedSVG
  //         }
  //       }
  //     }
  //   }
  // `)

  return (
    <section className={className}>
      <AltTitle center tagline={data.file.tagline} title={data.file.title} />
      <div className='wrapper'>
        <TallSquares
          style={{
            position: 'absolute',
            left: '0',
          }}
        />

        <div className='content-wrapper'>
          <Img className='img' fluid={data.file.image.fluid} />
          <div className='bullets'>
            <div className='bullet-1'>
              <span className='icon'>
                <FaRegThumbsUp />
              </span>
              <h4 className='iconTitle'>{data.file.bullet1Title}</h4>
              <p className='text'>{data.file.bullet1Paragraph}</p>
            </div>
            <div className='bullet-2'>
              <span className='icon'>
                <FaPiggyBank />
              </span>
              <h4 className='iconTitle'>{data.file.bullet2Title}</h4>
              <p className='text'>{data.file.bullet2Paragraph}</p>
            </div>
            <div className='bullet-3'>
              <span className='icon'>
                <FaBullhorn />
              </span>
              <h4 className='iconTitle'>{data.file.bullet3Title}</h4>
              <p className='text'>{data.file.bullet3Paragraph}</p>
            </div>
          </div>
        </div>

        <TallSquares
          style={{
            position: 'absolute',
            right: '0',
          }}
        />
      </div>
    </section>
  );
};

const whyInfluencers = styled(WhyInfluencers)`
  .wrapper {
    display: flex;
    position: relative;
    width: 100%;
    margin: 8.5rem auto 0;
    justify-content: center;
    align-items: center;
  }

  .content-wrapper {
    display: flex;
    justify-content: center;
    position: relative;
    @media screen and (max-width: 900px) {
      flex-direction: column;
      align-items: center;
    }
    @media screen and (max-width: 480px) {
      flex-direction: column;
    }
  }
  .img {
    width: 50vw;
    @media screen and (max-width: 900px) {
      width: 95vw;
      margin-bottom: 5rem;
    }
  }
  .bullets {
    width: 40rem;
    margin-left: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 900px) {
      background-color: var(--BgColor);
      border-radius: 10px;
      padding: 2rem;
      width: 88vw;
      margin: 0;
      z-index: 110;
    }
  }

  .bullets:before {
    content: '';
    position: absolute;
    width: 70rem;
    height: 55rem;
    background-color: var(--BgColor);
    transform: translateY(-50%);
    top: 50%;
    right: -2rem;
    z-index: -1;
    border-radius: 10px;

    @media screen and (max-width: 900px) {
      display: none;
    }
  }
  .icon {
    display: inline;
    background: white;
    padding: 1rem;
    border-radius: 50%;
    color: #5b6b7a;
    font-size: 1.5rem;
  }
  .iconTitle {
    display: inline;
    font-size: 1.8rem;
    font-weight: 600;
    color: var(--SecondaryColor);
    margin-left: 1rem;
    line-height: 1.5;
  }
  .text {
    display: block;
    font-size: 1.4rem;
    font-weight: 400;
    margin-left: 5rem;
    line-height: 1.4;
  }
`;
export default whyInfluencers;
